import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-mark-delivery-proof',
  templateUrl: './mark-delivery-proof.component.html',
  styleUrls: ['./mark-delivery-proof.component.scss']
})
export class MarkDeliveryProofComponent implements OnInit {

  deliveryReciept;
  invoice_id;
  order_id;
  invoice_details;
  shipmentNo;
  proofUploaded: boolean;
  uploaded_file_name="";

  constructor(
    public dialogref: MatDialogRef<MarkDeliveryProofComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService
  ) { }

  private paymentfilesControl = new FormControl(null, FileUploadValidators.filesLimit(1));
  public demoForm = new FormGroup({
    files: this.paymentfilesControl
  });

  ngOnInit() {
    this.order_id = this.data["order_id"];
    this.invoice_id = this.data["invoice_id"];
    this.invoice_details = this.data["invoice_details"];
    this.shipmentNo = this.invoice_details.vendor_shipments[0].reference_number
    this.paymentFile();

  }

  paymentFile() {
    const file = this.demoForm.get('files')
    file.valueChanges.subscribe(
      (res: any) => {
        console.log(res.length)        
        this.uploaded_file_name = res[0].name
        this.deliveryReciept = res[0];
        if (res.length = 0) {
          this.proofUploaded = false;
        }        
        else {
          this.proofUploaded = true;
        }
      }
    )
  }

  close() {
    this.dialogref.close();
  }

  submit() {
    let formData = new FormData();

    formData.append('vendor_shipment[delivery_receipt]', this.deliveryReciept)

    this.adminService.addDeliveryReceipt(this.order_id, this.invoice_id, formData).subscribe(
      res => {
        this.toastr.success('Delivery Proof has been Submitted', 'Success');
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.close();
      }

    );

  }

}
